export default __webpack_public_path__ + "static/media/error-signal.3e9e1659.wav";